class TestimonialsCarouselComponent extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('.testimonials__viewport');
    this.prevBtn = this.querySelector('[data-testimonials-prev]');
    this.nextBtn = this.querySelector('[data-testimonials-next]');
    if (!this.viewport) return;

    this.handlePrev = this.handlePrev.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleScroll = this.debounce(this.updateButtons.bind(this), 80);
    this.handleResize = this.debounce(this.updateButtons.bind(this), 150);

    this.prevBtn?.addEventListener('click', this.handlePrev);
    this.nextBtn?.addEventListener('click', this.handleNext);
    this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleResize);

    this.updateButtons();
  }

  disconnectedCallback() {
    this.prevBtn?.removeEventListener('click', this.handlePrev);
    this.nextBtn?.removeEventListener('click', this.handleNext);
    this.viewport?.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }

  getCardWidth() {
    const track = this.viewport.querySelector('.testimonials__track');
    const firstCard = track?.firstElementChild;
    if (!firstCard) return this.viewport.clientWidth;
    const styles = getComputedStyle(track);
    const gap = parseFloat(styles.columnGap) || parseFloat(styles.gap) || 0;
    return firstCard.getBoundingClientRect().width + gap;
  }

  handlePrev() {
    this.viewport.scrollBy({ left: -this.getCardWidth(), behavior: 'smooth' });
  }

  handleNext() {
    this.viewport.scrollBy({ left: this.getCardWidth(), behavior: 'smooth' });
  }

  updateButtons() {
    if (!this.prevBtn || !this.nextBtn) return;
    const { scrollLeft, scrollWidth, clientWidth } = this.viewport;
    const tolerance = 4;
    const atStart = scrollLeft <= tolerance;
    const atEnd = scrollLeft + clientWidth >= scrollWidth - tolerance;
    const noOverflow = scrollWidth <= clientWidth + tolerance;

    this.prevBtn.toggleAttribute('disabled', atStart || noOverflow);
    this.nextBtn.toggleAttribute('disabled', atEnd || noOverflow);
    this.toggleAttribute('data-no-overflow', noOverflow);
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

if (!customElements.get('testimonials-carousel-component')) {
  customElements.define('testimonials-carousel-component', TestimonialsCarouselComponent);
}
